/* eslint-disable no-debugger */
import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from 'axios';

const initialState = {
  isLoading: false,
  error: '',
  clientMsg: '',
  status: true,
  createClientStatus: false,
  clientList: [],
  disableClientList: [],
  projectListByClient: [],
  checkProjectLinked: ''
};

const slice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // RESET ERROR
    resetClientError(state) {
      state.error = '';
    },
    // RESET MSG
    resetClientMsg(state) {
      state.clientMsg = '';
    },
    // RESET CREATE STATUS
    resetCreateClientStatus(state) {
      state.createClientStatus = false;
    },
    // HAS ERROR
    hasError(state, action) {
      const { message } = action.payload?.data;
      state.createClientStatus = false;
      state.isLoading = false;
      state.error = message;
    },
    // STATUS
    clientStatus(state, action) {
      state.isLoading = false;
      state.status = action.payload;
    },
    // GET CLIENT LIST
    getCLientListSuccess(state, action) {
      state.clientList = action.payload;
      state.isLoading = false;
    },
    // GET DISABLE CLIENT LIST
    getDisableClientSuccess(state, action) {
      state.disableClientList = action.payload;
      state.isLoading = false;
    },
    // GET CLIENT LIST AT HEADER
    getProjectListByClientSuccess(state, action) {
      const { projects } = action.payload;
      if (projects?.length === 0) {
        state.checkProjectLinked = 'No project is linked with selected client';
        state.projectListByClient = projects;
      } else {
        state.projectListByClient = projects;
        state.checkProjectLinked = '';
      }
      state.isLoading = false;
    },
    resetProjectListByClient(state, action) {
      state.projectListByClient = [];
      state.isLoading = false;
      state.checkProjectLinked = '';
    },
    // GET DISABLE CLIENT LIST AT HEADER
    // getDisableClientHeaderSuccess(state, action) {
    //   state.disableClientListHEADER = action.payload;
    //   state.isLoading = false;
    // },
    // CREATE CLIENT
    createClientSuccess(state, action) {
      const newClient = action.payload;
      state.createClientStatus = true;
      state.isLoading = false;
      state.clientList = [...state.clientList, newClient];
    },
    // UPDATE CLIENT
    updateClientSuccess(state, action) {
      const client = action.payload;
      state.createClientStatus = true;
      const updateClient = map(state.clientList, (_client) => {
        if (_client.id === client.id) {
          return client;
        }
        return _client;
      });

      state.isLoading = false;
      state.clientList = updateClient;
    },
    // FILTER CLIENT
    filterClientSuccess(state, action) {
      const client = action.payload;
      state.isLoading = false;
      if (state.status) {
        state.clientList = client;
      } else {
        state.disableClientList = client;
      }
    },
    // DISABLE OR RESTORE CLIENT
    statusChangeSuccess(state, action) {
      if (action.payload.message) {
        state.clientMsg = action.payload.message;
      } else {
        const { id } = action.payload;
        const clientStatus = filter(
          state.status ? state.disableClientList : state.clientList,
          (client) => client.id !== id
        );
        state.isLoading = false;
        if (state.status) {
          state.createClientStatus = false;
          state.clientMsg = '';
          state.disableClientList = clientStatus;
        } else {
          state.createClientStatus = true;
          state.clientList = clientStatus;
        }
      }
    },
    // DELETE CLIENT
    deleteClientSuccess(state, action) {
      const { id } = action.payload;
      const deleteEvent = filter(state.disableClientList, (client) => client.id !== id);
      state.isLoading = false;
      state.disableClientList = deleteEvent;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { resetCreateClientStatus, resetClientError, resetClientMsg, resetProjectListByClient } = slice.actions;

// ----------------------------------------------------------------------

// GET CLIENT LIST GET
export function getClientList(status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/createclient/filter/item/?status=${status}`
      });
      if (status) {
        dispatch(slice.actions.getCLientListSuccess(response.data));
      } else {
        dispatch(slice.actions.getDisableClientSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// GET CLIENT LIST AT HEADER
export function getProjectListByClient(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/file-management-system/client/project/details/?client_ids=${id}`
      });
      dispatch(slice.actions.getProjectListByClientSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// CREATE CLIENT POST
export function createClient(clientData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: 'http://smartcollect-api.cp360apps.com/createclient/',
        data: clientData
      });
      dispatch(slice.actions.createClientSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// EDIT AND UPDATE CLIENT PUT
export function updateClient(clientData, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/createclient/${id}/`,
        data: clientData
      });
      dispatch(slice.actions.updateClientSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// SEARCH AND FILTER CLIENT GET
export function filterClient(pageStatus, name) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.clientStatus(pageStatus));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/createclient/filter/item/?client_name=${name}&status=${pageStatus}`
      });
      dispatch(slice.actions.filterClientSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DISABLING OR RESTORING OF PARTICULAR CLIENT GET
export function statusChange(id, status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.clientStatus(status));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/createclient/update-status-${status}/${id}/`
      });
      dispatch(slice.actions.statusChangeSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DELETE CLIENT DELETE
export function deleteClient(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'delete',
        url: `http://smartcollect-api.cp360apps.com/createclient/delete/${id}/`
      });
      dispatch(slice.actions.deleteClientSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}
